
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ktn-lookup",
      function () {
        return require("private-next-pages/ktn-lookup.tsx");
      }
    ]);
  